module.exports = __webpack_public_path__ + "static/media/pf.38fcbc6a.png";